import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import {
  NzTableModule,
  NzTableQueryParams,
  NzTableSortOrder,
} from 'ng-zorro-antd/table'
import { Observable } from 'rxjs'

import { LabelPipe } from '../../pipes/label.pipe'
import { ButtonComponent } from '../button/button.component'

export interface CellTemplateContext {
  index: number
  currentRow: TableDataBase
  item: unknown
}

export type TableColumn = {
  key: string
  label: Observable<string> | string
  title?: string
  sort?: boolean
  width?: string
  align?: 'left' | 'right' | 'center'
  fixLeft?: string | boolean
  fixRight?: string | boolean
  cellTemplate?: TemplateRef<CellTemplateContext>
  class?: string
}

export type ChangeEventParams = {
  pageIndex: number
  pageSize: number
  sort: Array<{
    key: string
    value: NzTableSortOrder
  }>
}

export type TableDataBase = {
  id: string
  [key: string]: unknown
}

@Component({
  selector: 'app-table',
  imports: [
    ButtonComponent,
    SvgIconComponent,
    TranslatePipe,
    NzTableModule,
    NgClass,
    NgTemplateOutlet,
    AsyncPipe,
    LabelPipe,
  ],
  templateUrl: './table.component.html',
})
export class TableComponent {
  @Input() public tableColumns: TableColumn[] = []
  @Input() public tableData: TableDataBase[] = []

  @Input() public isLoading: boolean = false
  @Input() public scroll!: { x?: string; y?: string }
  @Input() public customNoResultText?: string

  // prevent wrong call on init - https://github.com/NG-ZORRO/ng-zorro-antd/issues/6391
  private onQueryParamsChangeTriggerFlag: boolean = false

  @Input() public total: number = 0
  @Input() public pageSize: number = 30
  @Input() public pageIndex: number = 1

  public _defaultSorting: { [key: string]: NzTableSortOrder } = {}
  @Input() public set defaultSorting(
    val: { key: string; value: NzTableSortOrder }[]
  ) {
    this._defaultSorting = Object.fromEntries(val.map(Object.values))
  }

  @Output() public changeHandler = new EventEmitter<ChangeEventParams>()

  public constructor() {}

  public onTableSortChange(event: NzTableQueryParams): void {
    // prevent wrong call on init - https://github.com/NG-ZORRO/ng-zorro-antd/issues/6391
    if (!this.onQueryParamsChangeTriggerFlag) {
      this.onQueryParamsChangeTriggerFlag = true
      return
    }

    this.changeHandler.emit({
      sort: event.sort,
      pageIndex: event.pageIndex,
      pageSize: event.pageSize,
    })
  }
}
